import { render, staticRenderFns } from "./storeGroup.vue?vue&type=template&id=f8f5cd54&scoped=true"
import script from "./storeGroup.vue?vue&type=script&lang=js"
export * from "./storeGroup.vue?vue&type=script&lang=js"
import style0 from "./storeGroup.vue?vue&type=style&index=0&id=f8f5cd54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f5cd54",
  null
  
)

export default component.exports